import { render } from "./ConsultaProdutos.vue?vue&type=template&id=20bba1b5&scoped=true"
import script from "./ConsultaProdutos.vue?vue&type=script&lang=js"
export * from "./ConsultaProdutos.vue?vue&type=script&lang=js"

import "./ConsultaProdutos.vue?vue&type=style&index=0&id=20bba1b5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bba1b5"]])

export default __exports__